module.exports = __webpack_public_path__ + "media/components/assets/images/cooingklePackage/image6-f29592e17a394e42554614e4ede7ce76.png";